/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



//////////////////
// WEBPACK FOOTER
// (webpack)-merge/~/lodash/_freeGlobal.js
// module id = 309
// module chunks = 9